<template>
  <div class="tablex">
    <div
      v-if="cfg.loading"
      class="table-loading-spin"
    >
      <a-spin />
    </div>
    <!-- <div :class="scrollY ? 'scroll-y' : ''"> -->
    <div class="scroll-y">
      <a-table
        :scroll="{ x: $store.state.app.screenWidth < 768 || cfg.data.length === 0 ? '0px' : minWidth }"
        :row-key="cfg.rowKey || 'id'"
        :bordered="cfg.bordered === undefined ? true : cfg.bordered"
        :pagination="cfg.pagination === undefined ? false : cfg.pagination"
        :data-source="cfg.data"
        :loading="false"
        :columns="cfg.columns"
        :row-selection="cfg.showSelect ? { selectedRowKeys: cfg.selectedKeys, onChange: onSelectionChange} : null"
        :locale="{ emptyText: cfg.emptyText }"
        :size="cfg.size"
        :custom-row="cfg.customRow"
        :style="'min-width:' + ($store.state.app.screenWidth < 768 || cfg.data.length === 0 ? minWidth : '0px')"
        @expand="onExpand"
      >
        <slot />
      </a-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableTree',
  props: {
    cfg: {
      type: Object,
      default: () => ({})
    },
    minWidth: {
      type: String,
      required: true
    },
    scrollY: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onSelectionChange (selectedRowKeys, selectedRows) {
      this.$antdx.table.select(this.cfg, selectedRowKeys, selectedRows)
    },
    onExpand (expanded, record) {
      this.$emit('expand', record)
    }
  }
}
</script>

<style scoped>
  body, html{
    word-break: break-all
  }
  .tablex {
    position: relative;
  }

  .tablex >>> a {
    text-decoration: underline;
  }

  .tablex >>> td > a:not(:last-child) {
    margin-right: 8px;
  }

  .tablex .table-loading-spin {
    background-color: rgba(255, 255, 255, 0.65);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 1000;
  }

  .tablex .table-loading-spin >>> .ant-spin {
    position: absolute;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }
    .scroll-y{
    overflow: auto
  }
  .scroll-y::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  }
  .scroll-y::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
  background   : #fff;
  }
  .scroll-y::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background   : #fff;
  }
</style>
